import { useState } from "react";
import "../../assets/css/product.scss";

import closeSvg from "../../assets/images/icons/close.svg";

function DonateReceiptAgreeModal({ isOpen, onClose, onSuccess }) {
  const [checked, setChecked] = useState(false);

  const reset = () => {
    setChecked(false);
  };

  if (!isOpen) return null;

  return (
    <div className="product-donate-receipt-modal modal-wrap">
      <div
        className="overlay"
        onClick={() => {
          onClose();
        }}
      >
        <div className="modal" onClick={(e) => e.stopPropagation()}>
          <div>
            <button
              className="closeBtn"
              onClick={() => {
                onClose();
              }}
            >
              <img src={closeSvg} alt="" />
            </button>
          </div>
          <ul className="content">
            <li className="modal-title">Donation</li>
            <li className="title">키즈다 NIE캠페인 소개</li>
            <li className="agree-box">
              키즈다 NIE 캠페인은 교육, 학습, 문화콘텐츠로부터 소외된 도서산간
              지역, 다문화가정, 저소득층 어린이에게 세상을 보는 시각을 넓혀주는
              신문 구독을 장려해 기업과 독지가의 사회공헌활동 목적을
              극대화시키고 편의를 돕습니다. 키즈다 NIE 캠페인은 사회공헌의
              일환으로 어린이에게 키즈다를 보냄으로써 참된 ‘교육기부'를 실천하는
              기부캠페인 입니다.
              <br />
              <br />
              키즈다 앱 구독권 기증기간
              <br />
              *1개월 3개월 6개월 1년단위 이상
              <br />
              <br />
              키즈다 앱 구독권 기증금액 (최소 5만원)
              <br />
              *1개월 구독권 1만원 (최소 구독권 5개 : 5만원)
              <br />
              <br />
              연말정산 시 기부금 영수증 처리 가능
              <br />
              사업자 : 계산서 발행(비과세)
              <br />
              *PG결제 화면 현금영수증 발행 시 계산서 발행 불가
              <br />
              <br />
              기부금 영수증 발급을 원하시는 경우, 아래 기부금 영수증 신청
              동의란에 동의해 주세요.
            </li>
            <li className="agree">
              <div>(선택) 기부금 영수증 신청</div>
              <div>
                <label class="custom-checkbox">
                  <input
                    type="checkbox"
                    checked={checked}
                    onChange={(e) => setChecked(e.target.checked)}
                  />
                  <span></span>
                </label>
              </div>
            </li>
            <li className="submit">
              <button
                onClick={() => {
                  onSuccess && onSuccess(checked);
                  reset();
                }}
              >
                다음
              </button>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default DonateReceiptAgreeModal;
